import React from 'react';
import { Settings } from 'lucide-react';
import { useI18n } from '../contexts/I18nContext';

interface DashboardCustomizeHeaderProps {
  isCustomizeMode: boolean;
  onToggleCustomize: () => void;
  onOpenSettings: () => void;
}

export const DashboardCustomizeHeader: React.FC<DashboardCustomizeHeaderProps> = ({
  isCustomizeMode,
  onToggleCustomize,
  onOpenSettings,
}) => {
  const { t } = useI18n();

  const buttonStyle: React.CSSProperties = {
    backgroundColor: '#9333ea',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    padding: '10px 20px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontWeight: 600,
  };

  return (
    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
      <button
        type="button"
        onClick={onToggleCustomize}
        style={{
          ...buttonStyle,
          backgroundColor: isCustomizeMode ? '#7e22ce' : '#9333ea',
        }}
      >
        {isCustomizeMode ? t('dashboardDoneCustomize') : t('dashboardCustomize')}
      </button>
      <button type="button" onClick={onOpenSettings} style={buttonStyle}>
        <Settings size={18} />
        {t('dashboardConfigureWidgets')}
      </button>
    </div>
  );
};
